import _ from 'lodash';
import { createSelector } from 'reselect';

export const getCategories = state => state.categories;

export const getCategoryCount = state => getCategories(state).length;

const getCategoryId = (state, categoryId) => categoryId;

const getCategorySlug = (state, categorySlug) => categorySlug;

export const getCategory = createSelector([getCategories, getCategoryId], (categories, categoryId) =>
  _.find(categories, category => category._id === categoryId)
);

export const getCategoryBySlug = createSelector([getCategories, getCategorySlug], (categories, categorySlug) =>
  _.find(categories, category => category.slug === categorySlug)
);

export const getHighestRank = createSelector([getCategories], categories =>
  Math.max(-1, ..._.map(categories, category => category.rank))
);



// WEBPACK FOOTER //
// ./app/selectors/categories-selectors.js